module.exports = __webpack_public_path__ + "static/media/service_img_4.79d9cb09.png";